(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog-weighted"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {

  /* Fit ordered, uncropped images into complete rows at every width. */
  document.querySelectorAll(".catalog-grid").forEach(grid => {
    const cards = Array.from(grid.children);
    const ratios = cards.map(card => {
      const img = card.querySelector("img");
      return Number(img.getAttribute("width")) / Number(img.getAttribute("height"));
    });
    let lastWidth = 0;
    function layoutRows() {
      const styles = getComputedStyle(grid);
      const width = grid.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
      if (width <= 0 || Math.abs(width - lastWidth) < .5) return;
      lastWidth = width;
      const gap = 12;
      const n = cards.length;
      const target = Math.min(340, Math.max(220, width / 4));
      const cost = Array(n + 1).fill(Infinity);
      const ends = Array(n);
      cost[n] = 0;
      for (let i = n - 1; i >= 0; i--) {
        let sum = 0;
        for (let j = i; j < n && j < i + 6; j++) {
          sum += ratios[j];
          if (window.innerWidth <= 480 && j > i) break;
          const height = (width - gap * (j - i)) / sum;
          const score = Math.pow(height - target, 2) * (j - i + 1) + cost[j + 1];
          if (score < cost[i]) { cost[i] = score; ends[i] = j + 1; }
        }
      }
      for (let i = 0; i < n;) {
        const end = ends[i];
        const sum = ratios.slice(i, end).reduce((a, b) => a + b, 0);
        const height = (width - gap * (end - i - 1)) / sum;
        for (let j = i; j < end; j++) {
          const imageWidth = height * ratios[j];
          cards[j].style.width = imageWidth + "px";
          cards[j].style.height = height + "px";
          cards[j].querySelector("img").sizes = Math.ceil(imageWidth) + "px";
        }
        i = end;
      }
      if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
    }
    layoutRows();
    new ResizeObserver(layoutRows).observe(grid);
  });

  /* GSAP scroll animation */
  if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray(".catalog-item").forEach((item, i) => {
      gsap.to(item, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: item,
          start: "top 90%"
        },
        delay: i * 0.05
      });
    });
  }

  /* Desktop image viewer */
  const overlay = document.getElementById("catalogFullscreen");
  const fullscreenImg = document.getElementById("fullscreenImg");
  const items = Array.from(document.querySelectorAll(".catalog-item img"));
  if (!overlay || !fullscreenImg || !items.length) return;
  const closeButton = overlay.querySelector(".catalog-viewer-close");
  const prevButton = overlay.querySelector(".catalog-viewer-prev");
  const nextButton = overlay.querySelector(".catalog-viewer-next");
  let currentIndex = 0;
  let previousFocus = null;
  let previousOverflow = "";

  /* Keep desktop controls 12px from the displayed image. */
  function positionViewerControls() {
    if (window.innerWidth <= 768) return;
    const imageRect = fullscreenImg.getBoundingClientRect();
    const overlayRect = overlay.getBoundingClientRect();
    if (!imageRect.width || !imageRect.height) return;
    overlay.style.setProperty("--viewer-prev-left", Math.max(16, imageRect.left - overlayRect.left - 40) + "px");
    overlay.style.setProperty("--viewer-controls-right", Math.max(16, overlayRect.right - imageRect.right - 40) + "px");
    overlay.style.setProperty("--viewer-close-top", Math.max(16, imageRect.top - overlayRect.top) + "px");
  }
  new ResizeObserver(positionViewerControls).observe(fullscreenImg);
  fullscreenImg.addEventListener("load", positionViewerControls);

  const viewerImageCache = new Map();
  let imageRequest = 0;

  function prepareViewerImage(index) {
    const img = items[(index + items.length) % items.length];
    const src = img.dataset.fullscreenSrc || img.currentSrc || img.src;
    if (!viewerImageCache.has(src)) {
      const image = new Image();
      image.decoding = "async";
      const entry = { image, ready: false, promise: null };
      entry.promise = new Promise(resolve => {
        image.onload = async () => {
          try { await image.decode(); } catch (error) { /* Loaded image remains usable. */ }
          entry.ready = true;
          resolve(image);
        };
        image.onerror = () => { viewerImageCache.delete(src); resolve(null); };
      });
      viewerImageCache.set(src, entry);
      image.src = src;
      if (viewerImageCache.size > 5) viewerImageCache.delete(viewerImageCache.keys().next().value);
    }
    return viewerImageCache.get(src);
  }

  function showImage(index) {
    currentIndex = (index + items.length) % items.length;
    const request = ++imageRequest;
    const img = items[currentIndex];
    const fullImage = prepareViewerImage(currentIndex);
    fullscreenImg.width = Number(img.getAttribute("width"));
    fullscreenImg.height = Number(img.getAttribute("height"));
    // Respond immediately with the existing grid image while full resolution loads.
    fullscreenImg.src = fullImage.ready ? fullImage.image.src : (img.currentSrc || img.src);
    requestAnimationFrame(positionViewerControls);
    fullImage.promise.then(image => {
      if (!image || request !== imageRequest) return;
      fullscreenImg.src = image.src;
      requestAnimationFrame(positionViewerControls);
    });
    prepareViewerImage(currentIndex - 1);
    prepareViewerImage(currentIndex + 1);
  }

  function openViewer(index) {
    if (window.innerWidth <= 768) return;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    showImage(index);
    overlay.classList.add("active");
    overlay.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    closeButton.focus({ preventScroll: true });
  }

  function closeViewer() {
    if (!overlay.classList.contains("active")) return;
    overlay.classList.remove("active");
    document.body.style.overflow = previousOverflow;
    if (previousFocus && previousFocus.focus) previousFocus.focus({ preventScroll: true });
    overlay.setAttribute("aria-hidden", "true");
  }

  items.forEach((img, index) => img.addEventListener("click", () => openViewer(index)));
  closeButton.addEventListener("click", closeViewer);
  prevButton.addEventListener("click", () => showImage(currentIndex - 1));
  nextButton.addEventListener("click", () => showImage(currentIndex + 1));
  overlay.addEventListener("click", event => {
    if (event.target === overlay || event.target === fullscreenImg) closeViewer();
  });
  document.addEventListener("keydown", event => {
    if (!overlay.classList.contains("active")) return;
    if (event.key === "Escape") { event.preventDefault(); closeViewer(); }
    if (event.key === "ArrowLeft") { event.preventDefault(); showImage(currentIndex - 1); }
    if (event.key === "ArrowRight") { event.preventDefault(); showImage(currentIndex + 1); }
    if (event.key === "Tab") {
      const buttons = [closeButton, prevButton, nextButton];
      const activeIndex = buttons.indexOf(document.activeElement);
      event.preventDefault();
      buttons[(activeIndex + (event.shiftKey ? 2 : 1)) % buttons.length].focus();
    }
  });
  window.addEventListener("resize", () => {
    if (window.innerWidth <= 768) closeViewer();
    else positionViewerControls();
  });

});

  } catch(e) { console.error(e); }
})();
})();
